export const appcat = 'taxi';